import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EmployRoutingModule } from './employ-routing.module';
import { EmployComponent } from './employ.component';


@NgModule({
  declarations: [EmployComponent],
  imports: [
    CommonModule,
    EmployRoutingModule
  ]
})
export class EmployModule { }
